var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<web-component> <div class=\"logo_wrapper\" style=\"width: 180px\"> <div class=\"q_logo\"> <a itemprop=\"url\" href=\"{{$ctrl.homePath}}{{$ctrl.home}}\" style=\"visibility: visible\"> <img itemprop=\"image\" class=\"normal\" ng-src=\"{{$ctrl.logo}}\" alt=\"Logo\" style=\"height: 100%\"> </a> </div> </div> </web-component>";
var id1="winresLogo.html";
ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresLogo/winresLogo.html
// module id = 314
// module chunks = 2